import {  React } from "react";

function Tjanster () {

    return(
         <section className="flex flex-col items-center py-14 px-6 bg-beige-light ">
            <div>
                <h2 className="text-2xl md:text-3xl font-serif mb-6 ">Tjänster</h2>
                <div className="space-y-4 ">
                <p className="leading-relaxed md:leading-normal max-w-prose">Våra behandlingar inkluderar klippning, alla typer av färgbehandlingar, K18-behandlingar, rensningar, styling, permanent, fransar och bryn, samt extensions och hårdelar. Vi erbjuder ett brett utbud av behandlingar och skräddarsyr varje besök efter dig och ditt hår.</p>
                </div>
            </div>
            <div className="mt-8">

                <h2 className="text-2xl md:text-3xl font-serif mb-6 ">Våra samarbetspartners</h2>
                <div className="space-y-4 ">
                    <p className="leading-relaxed md:leading-normal max-w-prose ">I salongen arbetar vi med noggrant utvalda varumärken såsom Kevin Murphy, ELEVEN Australia, K18 och Malibu C, för att säkerställa hållbara resultat och ett hår i bästa möjliga skick.</p>
                </div>
                </div>
                <div className="py-10 px-6  ">
                <div className=" grid grid-cols-2 rounded rounded-sm md:grid-cols-2 gap-6 items-center justify-items-center">
                    <img
                        src="/logos/eleven2.png"
                        alt="Eleven australia"
                        className="h-32 w-full object-contain mx-auto"
                    />
                    <img
                        src="/logos/Livingproof.png"
                        alt="Eleven australia"
                        className="h-32 w-full object-contain mx-auto"
                    />
                    <img
                        src="/logos/kevin2.png"
                        alt="Kevin.Murphy"
                        className="h-32 w-full object-contain mx-auto"
                    />
                    <img
                        src="/logos/maliibuc2.png"
                        alt="MalibuC"
                        className="h-32 w-full object-contain mx-auto"
                    />
                    <div className="col-span-2">
                    <img
                        src="/logos/k182.png"
                        alt="k18"
                        className=" h-32 w-full object-contain mx-auto"
                    />
                    </div>
                    <div className="col-span-2">
                        <img
                            src="/logos/k18blonde.png"
                            alt="Blonde Solutions"
                            className="h-32  w-full object-contain mx-auto"
                        />
                    </div>
                </div>
                
            </div>
        </section>

    )
}

export default Tjanster;